<template>
    <div id="details">
        <v-container>
            <h1 class="page-title mouse-hover hover-invert">BlueBOT</h1>
            <div class="details-content">
                <v-row justify="center" align="center">
                    <v-col cols="12" md="8" lg="6">
                        <div class="detail-card">
                            <!-- <h2 class="detail-title mouse-hover hover-invert">BlueBOT</h2> -->
                            <div class="detail-description">
                                <p class="mouse-hover hover-invert">
                                    Το BlueBOT είναι ένα υποβρύχιο ρομπότ που αποτρέπει την ανάπτυξη βιορρύπανσης στο κύτος των πλοίων και παρέχει βέλτιστη ενεργειακή απόδοση ανεξάρτητα από το προφίλ λειτουργίας του σκάφους.
                                </p>
                                <p class="mouse-hover hover-invert">
                                    Το BlueBOT είναι ένα υποβρύχιο ερπυστριοφόρο ρομπότ που χρησιμοποιεί ελαστομερείς ιμάντες που διατηρούνται σε επαφή με το κύτος χρησιμοποιώντας ισχυρούς μόνιμους μαγνήτες. Χάρη στο προηγμένο λογισμικό πλοήγησης, το ρομπότ μπορεί να λειτουργήσει αυτόνομα ακολουθώντας τη βέλτιστη διαδρομή, ενώ είναι επίσης δυνατή η απομακρυσμένη λειτουργία από έναν χρήστη.
                                </p>
                                <p class="mouse-hover hover-invert">
                                    Ο έξυπνος εντοπισμός της θέσης του ερπυστριοφόρου σε συνδυασμό με τους ενσωματωμένους αλγόριθμους αναγνώρισης βιορρύπανσης που βασίζονται στην τεχνητή νοημοσύνη χρησιμοποιούνται για την αυτοματοποιημένη ποσοτικοποίηση της, την δημιουργία μιας αναφοράς και του αντίστοιχου χάρτη στο κύτος, κατάλληλης για χρήση με τις αρχές, καθώς και την πλήρη καταγραφή του καθαρισμού με βίντεο.
                                </p>
                            </div>
                            <div class="detail-image-container">
                                <v-img
                                    src="@/assets/details/Digital Products_Poster_BlueBOT.jpg"
                                    contain
                                    class="detail-image"
                                    alt="BlueBOT Poster"
                                ></v-img>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </v-container>
    </div>
</template>

<style scoped>
#details {
    padding-top: var(--abh);
    background: rgba(7, 28, 52, 0.8);
    min-height: calc(var(--vh, 1vh) * 100);
}

.details-content {
    padding: 2rem 0;
}

.detail-card {
    background: rgba(32, 92, 242, 0.05);
    border: 1px solid rgba(32, 92, 242, 0.2);
    border-radius: 16px;
    padding: 2rem;
    margin: 2rem 0;
}

.detail-title {
    color: var(--v-primary-base);
    text-align: center;
    margin-bottom: 1.5rem;
}

.detail-description {
    color: #ECEAEA;
    margin-bottom: 2rem;
    line-height: 1.6;
}

.detail-description p {
    margin-bottom: 1rem;
    text-align: justify;
}

.detail-image-container {
    margin-top: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
}

.detail-image {
    max-width: 100%;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(32, 92, 242, 0.3);
}

@media screen and (max-width: 960px) {
    .detail-card {
        padding: 1.5rem;
    }

    .detail-description p {
        text-align: left;
    }
}
</style>

<script>
export default {
    name: 'Details',
    mounted() {
        this.$store.state.app_bar_visible = true;
    }
}
</script>
